<!--
 * @Author: hucaili hucaili@qfei.cn
 * @Date: 2023-05-18 10:26:00
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2025-07-15 09:46:57
 * @FilePath: /fe-crm/src/components/xl-select-tree/xl-select-tree.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="comp-xl-select-tree">
    <jw-space direction="vertical">
      <div>
        <jw-button type="text" size="small" @click="addSelectTree">{{ $t('添加选项') }}</jw-button>
        <!-- <jw-popover>
          <icon-question-circle />
          <template #content> {{ $t('tips.keyNotRepeat') }} </template>
        </jw-popover> -->
        <jw-tooltip>
          <icon-question-circle size="18" />
          <!-- 这是提示文本  -->
          <template #content>
            <p>1.{{ $t('选项文本/key值不允许重复，无特殊需求') }}</p>
            <p>2.{{ $t('建议不要更改自动生成的选项key值') }}</p>
          </template>
        </jw-tooltip>
      </div>
      <jw-tree class="tree-demo" :data="treeData" ref="selectTree">
        <template #extra="nodeData">
          <jw-input @blur="blurData" v-model.trim="nodeData.label" :style="{ width: '150px', marginRight: '10px' }" :placeholder="nodeData.level == 1 ? $t('请输入一级选项名称') : nodeData.level == 2 ? $t('请输入二级选项名称') : nodeData.level == 3 ? $t('请输入三级选项名称') : ''"></jw-input>
          <jw-input @blur="blurData" v-model="nodeData.value" :disabled="nodeData.id && (tempSettingIds?.oldFieldIds?.includes(settingId) || isGlobal) ? true : false" @keyup="nodeData.value = nodeData.value.replace(/[\u4E00-\u9FA5]|\s+/g, '')" :style="{ width: '120px' }" :placeholder="$t('请输入key值')"></jw-input>
          <icon-minus-circle size="20" v-if="(treeDataList.length > 1 || nodeData.level > 1) && nodeData.id == ''" class="minus-icon" @click="onRemoveTree(nodeData)" />
          <template v-if="nodeData.id">
            <jw-switch v-if="tempSettingIds?.oldFieldIds?.includes(settingId) || isGlobal" v-model="nodeData.isEnabled" @change="updateIsenabled">
              <template #checked> {{ $t('启用') }} </template>
              <template #unchecked> {{ $t('停用') }} </template>
            </jw-switch>
            <template v-else>
              <icon-minus-circle size="20" v-if="treeDataList.length > 1 || nodeData.level > 1" :disabled="isGlobal" class="minus-icon" @click="onRemoveTree(nodeData)" />
            </template>
          </template>
          <icon-plus-circle size="20" v-if="nodeData.level < level" class="plus-icon" @click="onAddTree(nodeData)" />
        </template>
      </jw-tree>
    </jw-space>
  </div>
</template>

<script>
import { reactive, toRefs, ref, nextTick, watchEffect } from 'vue';
import { tools } from '@/utils/tools.js';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'XlSelectTree',
  props: {
    level: {
      //级联选择器默认不限制层级
      type: Number,
      default: 100
    },
    treeDataList: {
      //默认选项值
      type: Array,
      default() {
        return [{ key: '0-0', level: 1, label: '', value: '', id: '', isEnabled: true }];
      }
    },
    tempSettingIds: {
      //布局里新旧字段合集
      type: Object,
      default() {
        return {};
      }
    },
    settingId: {
      type: [Number, String],
      default: ''
    },
    isGlobal: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update'], //更新树数据，更新选项值
  setup(props, ctx) {
    const data = reactive({
      drag: false
    }); //扩展字段});
    // console.log(props.treeDataList);

    const treeData = ref(props.treeDataList);
    watchEffect(() => {
      treeData.value = props.treeDataList;
    });

    const selectTree = ref();
    //添加级联选项
    const onAddTree = (nodeData) => {
      const children = nodeData.children || [];
      const tool = tools.randomString();
      children.push({
        key: nodeData.key + '-' + (children.length + 1),
        level: nodeData.level + 1,
        label: '',
        value: `${tool}`,
        id: '',
        isEnabled: true
      });
      nodeData.children = children;
      nextTick(() => {
        selectTree.value.expandAll(true); //默认全部展开
      });
      ctx.emit('update', treeData.value);
    };
    //禁用/启用
    // const updateIsenabled = (nodeData) => {
    //   nodeData.isEnabled = !nodeData.isEnabled;
    //   ctx.emit('update', treeData.value);
    // };
    const updateIsenabled = () => {
      ctx.emit('update', treeData.value);
    };
    //删除选项
    const onRemoveTree = (nodeData) => {
      remove(nodeData, treeData.value);
      ctx.emit('update', treeData.value);
    };
    const remove = (nodeData, treeData) => {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].key == nodeData.key) {
          treeData.splice(i, 1);
          break;
        }
        if (treeData[i].children && treeData[i].children.length) {
          remove(nodeData, treeData[i].children);
        }
        if (treeData[i].children == 0) treeData[i].children = undefined;
      }
    };
    //添加选项
    const addSelectTree = () => {
      const len = ref(0);
      const tool = tools.randomString();
      //   console.log(treeData);
      if (treeData.value?.length) {
        //设置选项的key唯一
        // len.value = Number(treeData.value[treeData.value.length - 1]['key']?.split('-')[1]) + 1;
        if (treeData.value[treeData.value.length - 1]['key']?.split('-')?.length == 1) {
          len.value = Number(treeData.value[treeData.value.length - 1]['key']?.split('-')[0]) + 1;
        }
        if (treeData.value[treeData.value.length - 1]['key']?.split('-')?.length > 1) {
          len.value = Number(treeData.value[treeData.value.length - 1]['key']?.split('-')[1]) + 1;
        }
      }
      treeData.value.push({
        key: '0-' + len.value,
        level: 1,
        label: '',
        value: `${tool}`,
        id: '',
        isEnabled: true
      });

      ctx.emit('update', treeData.value);
    };
    const blurData = () => {
      ctx.emit('update', treeData.value);
    };
    // 默认全部展开
    const expandAll = () => {
      nextTick(() => {
        selectTree.value.expandAll(true); //默认全部展开
      });
    };
    return {
      treeData,
      onAddTree,
      updateIsenabled,
      onRemoveTree,
      addSelectTree,
      selectTree,
      expandAll,
      ...toRefs(data),
      blurData
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-select-tree.less';
</style>
